// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-bounce1{animation:v-bounceStretchDelay 2s ease-in-out 1s infinite;animation-fill-mode:both}.v-bounce2{animation:v-bounceStretchDelay 2s ease-in-out 0s infinite;animation-fill-mode:both}@keyframes v-bounceStretchDelay{0%,to{transform:scale(0)}50%{transform:scale(1)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
